import { styled } from 'styled-components';

import { colors, fontWeights, transition } from 'theme/theme';

export const CmsTableOfContentsContainer = styled.div<{
  $indicatorTop: number;
  $indicatorHeight: number;
}>`
  position: relative;
  margin-top: 130px;
  padding-left: 29px;

  &::after,
  &::before {
    border-radius: 2px;
    content: '';
    position: absolute;
    left: 0;
  }

  &::before {
    top: 56px;
    height: calc(100% - 63px);
    width: 5px;
    background: ${colors.calloutGrey};
  }

  &::after {
    top: 63px;
    width: 5px;
    height: 1px;
    background-image: linear-gradient(
      to bottom,
      ${colors.brandBlue},
      ${colors.skyBlue}
    );
    transition: all ${transition};
    ${({ $indicatorTop, $indicatorHeight }) => `
      height: ${$indicatorHeight}px;
      top: ${$indicatorTop}px;
    `}
  }
`;

export const CmsTableOfContentsLink = styled.div<{ $active?: boolean }>`
  display: block;
  padding: 10px 0;
  overflow: hidden;
  color: ${colors.mediumContentGrey};
  line-height: 18.5px;
  font-size: 14px;
  text-align: left;
  font-weight: normal;

  &:hover {
    font-weight: ${fontWeights.semiBold};
  }

  cursor: pointer;
  ${(props) => props.$active && `font-weight: ${fontWeights.semiBold}`};
`;

export const CmsTableOfContentsChildContainer = styled.div`
  padding-left: 10px;
`;

export const CmsTableOfContentsChildren = styled.div<{
  $open?: boolean;
  $numChildren: number;
}>`
  transition: all ${transition};
  overflow: hidden;
  ${(props) => `max-height: ${props.$numChildren * 57}px;`};
  ${(props) => !props.$open && `max-height: 0;`};
`;
